/**
 * @author Gananath Athukorala
 * @version 0.1
 */

import React, { useState } from "react"
import labelsEN from "../../../locales/en/translation.json"
import CreateNewAccountModal from "./components/CreateNewAccountModal"
import ApproveTable from "./components/ApproveTable"
import { Box, Fab } from "@mui/material"
import { Badge, Tabs, Tab } from "react-bootstrap"
import PendingTable from "./components/PendingTable"
import AddIcon from "@mui/icons-material/Add"

const UserAccounts = () => {
  const AUTO_APPROVE = localStorage.getItem("SET_AUTO_APPROVE")

  const [createModalOpen, setCreateModalOpen] = useState(false)
  const [isUpdate, setIsUpdate] = useState(false)
  const [pendRowCount, setPendRowCount] = useState(0)

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <div style={{ display: "flex", position: "relative" }}>
          <h1>{labelsEN.app_useraccounts_page_title}</h1>
          <Fab
            onClick={() => setCreateModalOpen(true)}
            color="success"
            variant="extended"
            sx={{ position: "absolute", right: 0 }}>
            <AddIcon sx={{ mr: 1 }} />
            Create new
          </Fab>
        </div>
        <br />
        <br />
        <Tabs
          defaultActiveKey="Approved"
          id="uncontrolled-tab-example"
          className="mb-3">
          <Tab eventKey="Approved" title={"Approved"}>
            <ApproveTable isUpdate={isUpdate} setIsUpdate={setIsUpdate} />
          </Tab>
          {AUTO_APPROVE === "false" && (
            <Tab
              eventKey="Pending"
              title={
                <React.Fragment>
                  Pending <Badge bg="danger">{pendRowCount}</Badge>
                </React.Fragment>
              }>
              <PendingTable
                isUpdate={isUpdate}
                setIsUpdate={setIsUpdate}
                pendRowCount={pendRowCount}
                setPendRowCount={setPendRowCount}
              />
            </Tab>
          )}
        </Tabs>
      </Box>
      <CreateNewAccountModal
        open={createModalOpen}
        setIsUpdate={setIsUpdate}
        onClose={() => {
          setCreateModalOpen(false)
        }}
      />
    </div>
  )
}

export default UserAccounts
